module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VlHSAr/tc-custom/9781429982160.jpg?1737776254516",
      "alt": "This image is the cover for the book The King's Name, Sulien"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The King's Name, Sulien\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The warrior Sulien ap Gwien and her lord King Urdo have finally united the land of Tir Tanagiri into a kingdom ruled by justice under a single code of law. But where many see a hopeful future for the land, others believe they sense the seeds of a new tyranny. Soon Tir Tanagiri faces the blight of civil war, and Sulien ap Gwien must take up arms against former comrades and loved ones, fighting harder and harder to hold on to Urdo's shining dream."), _c('br'), _c('br'), _vm._v("Continuing the epic begun in "), _c('i', [_vm._v("The King's Peace")]), _vm._v(", this new novel brings the story of Sulien ap Gwien to a rousing and moving conclusion."), _c('br'), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jo Walton\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0